import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import ModalManager from '@/components/Modal/ModalManager';
import PopupManager from '@/components/Popup/PopupManager';
import ToastManager from '@/components/Toast/ToastManager';
import DetailModalManager from '@/features/Commons/DetailModal/DetailModalManager';

const PluginLayout = () => {
  return (
    <Style>
      <ToastManager />
      <PopupManager />
      <DetailModalManager />
      <ModalManager />

      <Outlet />
    </Style>
  );
};

const Style = styled.div`
  padding: 20px;
`;

export default PluginLayout;
